import { licenseTableKeys } from '../../../Licenses/components/LicensesTable/tableConfigs';
import { type ILicenseSearchResult } from '../../../Licenses/store/types';
import { type ITableColumn } from '../../../../components/TableGrid';
import LicenseStatus from '../../../../components/LicenseStatus';

import { formatDate } from '../../../../helpers/dateHelpers';

import styles from './LicenseChildrenTable.module.scss';

export const getChildrenTableColumns = (
  licenseAbbreviation: string,
  t: (key: string, options?: Record<string, unknown>) => string
): ITableColumn<ILicenseSearchResult>[] => [
  {
    key: licenseTableKeys.licenseType,
    name: t('Type of {{licenseAbbreviation}}', { licenseAbbreviation: t(licenseAbbreviation) }),
    sortable: true,
    className: styles.licenseTypeCell,
  },
  {
    key: licenseTableKeys.requestNumber,
    name: t('Request Number'),
    sortable: true,
    className: styles.cell,
  },
  {
    key: licenseTableKeys.requestDate,
    name: t('Request Date'),
    sortable: true,
    colRenderer: (requestDate: string) => formatDate(requestDate),
    className: styles.cell,
  },
  {
    key: licenseTableKeys.status,
    name: t('Status'),
    sortable: true,
    colRenderer: (status, index, { ogaStatus, ogaStatusInNationalLang }) => (
      <LicenseStatus status={status} ogaStatus={ogaStatus} ogaStatusInNationalLang={ogaStatusInNationalLang} />
    ),
    className: styles.cell,
  },
];
